import { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@clerk/clerk-react";
import { useCurrentUser } from "../lib/useCurrentUser";

const CLERK_LOAD_TIMEOUT_MS = 10_000;

export default function ProtectedRoute() {
  const { isLoaded, isSignedIn } = useAuth();
  const { accessStatus, loading: meLoading } = useCurrentUser();
  const location = useLocation();
  const [timedOut, setTimedOut] = useState(false);

  useEffect(() => {
    if (isLoaded) return;
    const t = setTimeout(() => setTimedOut(true), CLERK_LOAD_TIMEOUT_MS);
    return () => clearTimeout(t);
  }, [isLoaded]);

  if (!isLoaded || (isSignedIn && meLoading)) {
    return (
      <div className="container-page py-24">
        <div className="surface mx-auto max-w-md p-6 text-center">
          <div className="mx-auto h-2 w-2 animate-pulse rounded-full bg-accent" />
          <p className="mt-3 text-sm text-slate-300">
            {timedOut
              ? "Auth is taking longer than expected. Check your network and Clerk configuration, then reload."
              : "Loading your session…"}
          </p>
          {timedOut && (
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="mt-4 rounded-md border border-white/10 px-3 py-1.5 text-xs text-slate-200 hover:bg-white/5"
            >
              Reload
            </button>
          )}
        </div>
      </div>
    );
  }
  if (!isSignedIn) {
    return (
      <Navigate
        to="/sign-in"
        replace
        state={{ from: location.pathname + location.search }}
      />
    );
  }
  if (accessStatus === "pending") {
    return <Navigate to="/access-pending" replace />;
  }
  return <Outlet />;
}
